import React from 'react';
import { UserPreviewTemplate } from 'themes/application/user/pages';
import { observer } from 'mobx-react';
import { UserPreviewViewStore } from 'application/user/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore) => new UserPreviewViewStore(rootStore), 'userPreviewViewStore')
@observer
class UserPreview extends React.Component {
    render() {
        return <UserPreviewTemplate {...this.props} />
    }
}

export default UserPreview;
